import PurchaseOrderStatus from "@/classes/component-classes/PurchaseOrderStatus";

export default class PurchaseOrderStatusExtended extends PurchaseOrderStatus{
    constructor() {

        super();

        this.rowId = '';
        this.readOnly = false;
        this.showAddButton = true;
        this.isEditing = false;
        this.isDeleting = false;
    }
}
